import { RESOLUTION_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue } from '../../../value/types.tsx';
import type { TransformedResolutionField } from '../types.tsx';
import messages from './messages.tsx';

const getResolutionValue: StringValue<TransformedResolutionField> = (field, formatMessage) => {
	if (field.value?.name) {
		return field.value?.name;
	}

	return formatMessage ? formatMessage(messages.unresolvedResolution) : '';
};

export const resolutionStringValueHandler = {
	[RESOLUTION_TYPE]: getResolutionValue,
};
